export default "__VITE_ASSET__BPgo$_s5__"